define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi",
	"csi/locale",
	"csi/reflection",
	"csi/heading/EnumAction",
	"SourcingOrders"
], function(declare,Memory,csi,locale,reflection,EnumAction,SourcingOrders) {

	return declare(EnumAction, {
		getStore: function(/*Context*/ctx, /*Heading*/h, /*String*/value, /*Boolean*/bAll) {
			var config  = reflection.getObject(SourcingOrders.CONFIG);

			var currentState = ctx.getNode().State;

			// summary: return store filled with possible state-transition actions
			var items = csi.transform(h.m_defActions.getActions(), function(a) {
				var hasWF = SourcingOrders.poStateChangeHasWorkflow(config, a.m_id, currentState)

				return a.hasAccess(ctx) ? {id: a.m_id, name: (hasWF ? locale.resource("POActionByWorkflow", [a.m_name]) : a.m_name)} : null;
			});

			// unfortunately the select control does not like empty id, so use non-empty one
			items.unshift({id: EnumAction.EMPTY, name: ""});
			return new Memory({data: items});
		}
	});
});